export default __webpack_public_path__ + "static/media/list_main_16_2.6775ef80.jpg";